const Request = require('./request');
const { getApiUrl } = require('../utils/environment');
const API_LINK = `${getApiUrl()}/api/`;

class Api extends Request {
  constructor() {
    super(API_LINK);
  }

  getCaptchaToken() {
    return window.grecaptcha
      .execute('6LfCPMAUAAAAAGPj2JvQRyB45mU8iJabAxT_jLu6', {
        action: 'submit',
      })
      .catch(() => 'no-token');
  }

  sendForm(data, options) {
    return this.postFormData('integration/form-data', data, options);
  }

  getVacancy(id, lang, failOnError) {
    const headers = { 'Accept-Language': lang };

    return this.get(`integration/recruitment/vacancies/${id}`, headers, failOnError);
  }

  getVacancies(lang) {
    const headers = { 'Accept-Language': lang };

    return this.get('integration/recruitment/vacancies', headers);
  }

  getDnsCheck(email) {
    const headers = { 'Email-Validation': email };

    return this.get('integration/validation/email', headers);
  }
}

module.exports = new Api();
